import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';

import WebhooksListModuleMC from '../../../modules/Webhooks/components/WebhooksListModuleMC';
import NavbarLayoutMC from '../../../layouts/NavbarLayoutMC';

const WebhooksScreenMC = () => {
  const { slug } = useParams();
  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);

  if (retailer_info && retailer_info.webhooks_enabled === false) {
    return <Navigate to={`/retailers/${slug || retailer_info.slug}/dashboard`} replace />;
  }

  return (
    <NavbarLayoutMC>
      <div className="container-fluid-no-padding px-30 py-20 w-100 bg-white store-content">
        <WebhooksListModuleMC />
      </div>
    </NavbarLayoutMC>
  );
};

export default WebhooksScreenMC;
